import type { ChessGameCollection } from "../models/chess-game-collection";
import type { ChessGameSource } from "../models/chess-game-model";
import { db } from "./db";

export const ChessGameCollectionRepository = {
    async add(collection: ChessGameCollection) {
        await db.collections.put(collection);
    },

    async getByUsernameAndSource(
        username: string,
        source: ChessGameSource
    ): Promise<ChessGameCollection | undefined> {
        return db.collections.where({ username, source }).first();
    },

    async updateSyncTime(id: string, lastSync: number): Promise<void> {
        await db.collections.update(id, { lastSync });
    },

    async get(id: string): Promise<ChessGameCollection | undefined> {
        return db.collections.get(id);
    },

    async getAll(): Promise<ChessGameCollection[]> {
        return db.collections.toArray();
    },

    async remove(id: string) {
        await db.collections.delete(id);
    },

    async update(id: string, changes: Partial<ChessGameCollection>) {
        await db.collections.update(id, changes);
    },
};
